import React, { useState } from 'react'
import SubscribeContainer from 'components_v2/Subscribe'
import { H2 } from 'ui/bend'
import AuthProviders from 'components_v2/AuthProviders'
import SignInForm from './SignInForm'
import { Button } from 'ui/bend'
import styled from 'styled-components'
import { Flex } from 'ui/chandra'
import AloSignupAndVerifyLinks from '../../components_v2/Membership/Edit/AloSignupAndVerifyLinks'
import ContentModalFP from '../../components_v2/SignIn/AloAccess/ContentModalFP'
import ExistingUserAloSignUp from '../../components_v2/SignIn/AloAccess/ExistingUserAloSignUp'
import SeparationLine from './AloAccess/SeparationLine'
import { useMeta, useTitle } from 'hooks/useMetaTitle'

const AloSubscribeContainer = styled(SubscribeContainer)({
  margin: '27px 20px 10px 20px',
  div: {
    maxWidth: '490px'
  }
})

const OneClickTextWrapper = styled(Flex)`
  padding: 32px 10px 16px;
  justify-content: center;
  color: #000;
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 133.333% */
  letter-spacing: 0.9px;
  text-transform: uppercase;
`

const OneTimePassCode = styled(Button)`
  font-family: ${(props) => props.theme.fonts.Proxima};
  display: flex;
  padding: 12px 32px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #000;
  color: #000;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.48px;
  background: #fff;
  width: 100%;
  text-transform: uppercase;
  &:hover {
    background-color: #fff !important;
    color: #000 !important;
  }
  &:focus {
    background-color: #fff !important;
    color: #000 !important;
  }
`

const SignInTitle = styled.div`
  color: #000;
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.396px;
  margin: 2px 0 16px 0;
`
const AloLinkWrapper = styled.div`
  margin-top: 20px;
`

const SignIn = ({
  hideSignUp = false,
  hideTerms = true,
  isSignupScreen = false
}) => {
  const [showSignup, setShowSignup] = useState(false)
  const [customerEmail, setCustomerEmail] = useState('')
  const [showOneTimePasscodeModal, setShowOneTimePasscodeModal] =
    useState(false)
  const [submitData, setSubmitData] = useState({})

  useTitle('Sign In')
  useMeta([
    {
      name: 'description',
      content:
        'Access your ALO Wellness Club account by logging in on this page.'
    }
  ])

  return (
    <>
      {Boolean(customerEmail) ? (
        <ExistingUserAloSignUp
          email={customerEmail}
          submitData={submitData}
          setCustomerEmail={setCustomerEmail}
        />
      ) : (
        <AloSubscribeContainer>
          <H2 pb='10px' textTransform='uppercase' textAlign='left' color='#000'>
            Sign In
          </H2>
          <SignInTitle>
            Sign in with the <b>same</b> email and password you used to join ALO
            Access.
          </SignInTitle>
          <SignInForm
            hideSignUp={hideSignUp}
            hideTerms={hideTerms}
            isSignupScreen={isSignupScreen}
          />
          <SeparationLine text={'forgot password?'} />
          <OneTimePassCode onClick={() => setShowOneTimePasscodeModal(true)}>
            Sign in with one-time passcode
          </OneTimePassCode>
          <OneClickTextWrapper>One Click Sign In</OneClickTextWrapper>
          <AuthProviders context='signin' />

          <AloLinkWrapper>
            <AloSignupAndVerifyLinks
              showSignup={showSignup}
              setShowSignup={setShowSignup}
              setCustomerEmail={setCustomerEmail}
              setSubmitData={setSubmitData}
              location='sign_in'
            />
          </AloLinkWrapper>
          {showOneTimePasscodeModal && (
            <ContentModalFP
              show={showOneTimePasscodeModal}
              onHide={setShowOneTimePasscodeModal}
              frompage='signin'
            />
          )}
        </AloSubscribeContainer>
      )}
    </>
  )
}

export default SignIn
